import React from 'react';
import './Loader.css';

const Loader = () => {
    return (
        <React.Fragment>
            <div className="flipping">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </React.Fragment>
    )
}

export default Loader